import { useShallow } from 'zustand/react/shallow';
import useLightboxStore from './store';

export const useLightbox = () =>
  useLightboxStore(
    useShallow((state) => ({
      createLightbox: state.createLightbox,
      destroyLightbox: state.destroyLightbox,
    })),
  );

export default useLightbox;
